import { PopulationMultipleChoice } from '../shared/interfaces';
import { TEST_IMAGE_TYPES, images } from '../data/images';
import { TEST_CHOICE_TYPES } from './choice-types';
import { TestAssociatedSuccessCriteria } from './test-associated-success-criteria.enum';

export const multiChoiceImageQuestions: {
  [key: number]: PopulationMultipleChoice;
} = {
  [TEST_CHOICE_TYPES.TEST_R_MCI_SHORT]: {
    question: {
      text: 'This is the verbal reading multi choice image short question?',
      displayText:
        'This is the visual reading multi choice image short question?',
    },
    answerChoices: [
      {
        id: '0',
        choice: {
          images: [images[TEST_IMAGE_TYPES.CORRECT]],
        },
      },
      {
        id: '1',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content: 'This is incorrect 1 - first incorrect targeted feedback',
            chartUrl: '/helix/Testing/MicrolessonsTesting/SampleTable.lexical',
          },
          secondIncorrect: {
            content: 'This is incorrect 1 - second incorrect targeted feedback',
          },
        },
      },
      {
        id: '2',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content: 'This is incorrect 2 - first incorrect targeted feedback',
            chartUrl: '/helix/Testing/MicrolessonsTesting/SampleTable.lexical',
          },
          secondIncorrect: {
            content: 'This is incorrect 2 - second incorrect targeted feedback',
          },
        },
      },
      {
        id: '3',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content: 'This is incorrect 3 - first incorrect targeted feedback',
            chartUrl: '/helix/Testing/MicrolessonsTesting/SampleTable.lexical',
          },
          secondIncorrect: {
            content: 'This is incorrect 3 - second incorrect targeted feedback',
          },
        },
      },
    ],
    answers: ['0'],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.MULTI_CHOICE_IMAGE,
    ],
  },
  [TEST_CHOICE_TYPES.TEST_R_MCI_MEDIUM]: {
    question: {
      text: 'This is the verbal reading multi choice image medium question? Added question text for medium length.',
      displayText:
        'This is the visual reading multi choice image medium question? Added question text for medium length.',
    },
    answerChoices: [
      {
        id: '0',
        choice: {
          images: [images[TEST_IMAGE_TYPES.CORRECT]],
        },
      },
      {
        id: '1',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content: 'This is incorrect 1 - first incorrect targeted feedback',
          },
          secondIncorrect: {
            content: 'This is incorrect 1 - second incorrect targeted feedback',
          },
        },
      },
      {
        id: '2',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content: 'This is incorrect 2 - first incorrect targeted feedback',
          },
          secondIncorrect: {
            content: 'This is incorrect 2 - second incorrect targeted feedback',
          },
        },
      },
      {
        id: '3',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content: 'This is incorrect 3 - first incorrect targeted feedback',
          },
          secondIncorrect: {
            content: 'This is incorrect 3 - second incorrect targeted feedback',
          },
        },
      },
    ],
    answers: ['0'],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.MULTI_CHOICE_IMAGE,
    ],
  },
  [TEST_CHOICE_TYPES.TEST_R_MCI_LONG]: {
    question: {
      text: 'This is the verbal reading multi choice image long question? Added text to the question in order to add longer question. More question text added here for length.',
      displayText:
        'This is the visual reading multi choice image long question? Added text to the question in order to add longer question. More question text added here for length.',
    },
    answerChoices: [
      {
        id: '0',
        choice: {
          images: [images[TEST_IMAGE_TYPES.CORRECT]],
        },
      },
      {
        id: '1',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content: 'This is incorrect 1 - first incorrect targeted feedback',
          },
          secondIncorrect: {
            content: 'This is incorrect 1 - second incorrect targeted feedback',
          },
        },
      },
      {
        id: '2',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content: 'This is incorrect 2 - first incorrect targeted feedback',
          },
          secondIncorrect: {
            content: 'This is incorrect 2 - second incorrect targeted feedback',
          },
        },
      },
      {
        id: '3',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content: 'This is incorrect 3 - first incorrect targeted feedback',
          },
          secondIncorrect: {
            content: 'This is incorrect 3 - second incorrect targeted feedback',
          },
        },
      },
    ],
    answers: ['0'],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.MULTI_CHOICE_IMAGE,
    ],
  },
  [TEST_CHOICE_TYPES.TEST_S_MCI_SHORT]: {
    question: {
      text: '¿Esta es la pregunta breve sobre verbal lectura de imágenes de opción múltiple?',
      displayText:
        '¿Esta es la pregunta breve sobre visual lectura de imágenes de opción múltiple?',
    },
    answerChoices: [
      {
        id: '0',
        choice: {
          images: [images[TEST_IMAGE_TYPES.CORRECT]],
        },
      },
      {
        id: '1',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'Esto es incorrecto 1: primer comentario dirigido incorrecto',
          },
          secondIncorrect: {
            content:
              'Esto es incorrecto 1 segundo de comentario dirigido incorrecto',
          },
        },
      },
      {
        id: '2',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'Esto es incorrecto 2: primer comentario dirigido incorrecto',
          },
          secondIncorrect: {
            content:
              'Esto es incorrecto 2 segundos de comentarios dirigidos incorrectos',
          },
        },
      },
      {
        id: '3',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'Esto es incorrecto 3: primer comentario dirigido incorrecto',
          },
          secondIncorrect: {
            content:
              'Esto es incorrecto. Comentarios dirigidos incorrectos de 3 segundos.',
          },
        },
      },
    ],
    answers: ['0'],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.MULTI_CHOICE_IMAGE,
    ],
  },
  [TEST_CHOICE_TYPES.TEST_S_MCI_MEDIUM]: {
    question: {
      text: '¿Esta es la pregunta del medio de verbal lectura de imágenes de opción múltiple? Se agregó texto de pregunta para longitud media.',
      displayText:
        '¿Esta es la pregunta del medio de visual lectura de imágenes de opción múltiple? Se agregó texto de pregunta para longitud media.',
    },
    answerChoices: [
      {
        id: '0',
        choice: {
          images: [images[TEST_IMAGE_TYPES.CORRECT]],
        },
      },
      {
        id: '1',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'Esto es incorrecto 1: primer comentario dirigido incorrecto',
          },
          secondIncorrect: {
            content:
              'Esto es incorrecto 1 segundo de comentario dirigido incorrecto',
          },
        },
      },
      {
        id: '2',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'Esto es incorrecto 2: primer comentario dirigido incorrecto',
          },
          secondIncorrect: {
            content:
              'Esto es incorrecto 2 segundos de comentarios dirigidos incorrectos',
          },
        },
      },
      {
        id: '3',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'Esto es incorrecto 3: primer comentario dirigido incorrecto',
          },
          secondIncorrect: {
            content:
              'Esto es incorrecto. Comentarios dirigidos incorrectos de 3 segundos.',
          },
        },
      },
    ],
    answers: ['0'],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.MULTI_CHOICE_IMAGE,
    ],
  },
  [TEST_CHOICE_TYPES.TEST_S_MCI_LONG]: {
    question: {
      text: '¿Esta es la pregunta larga sobre verbal lectura de imágenes de opción múltiple? Se agregó texto a la pregunta para agregar una pregunta más larga. Se agregó más texto de pregunta aquí para mayor extensión.',
      displayText:
        '¿Esta es la pregunta larga sobre visual lectura de imágenes de opción múltiple? Se agregó texto a la pregunta para agregar una pregunta más larga. Se agregó más texto de pregunta aquí para mayor extensión.',
    },
    answerChoices: [
      {
        id: '0',
        choice: {
          images: [images[TEST_IMAGE_TYPES.CORRECT]],
        },
      },
      {
        id: '1',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'Esto es incorrecto 1: primer comentario dirigido incorrecto',
          },
          secondIncorrect: {
            content:
              'Esto es incorrecto 1 segundo de comentario dirigido incorrecto',
          },
        },
      },
      {
        id: '2',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'Esto es incorrecto 2: primer comentario dirigido incorrecto',
          },
          secondIncorrect: {
            content:
              'Esto es incorrecto 2 segundos de comentarios dirigidos incorrectos',
          },
        },
      },
      {
        id: '3',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'Esto es incorrecto 3: primer comentario dirigido incorrecto',
          },
          secondIncorrect: {
            content:
              'Esto es incorrecto. Comentarios dirigidos incorrectos de 3 segundos.',
          },
        },
      },
    ],
    answers: ['0'],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.MULTI_CHOICE_IMAGE,
    ],
  },
  [TEST_CHOICE_TYPES.TEST_R_MCI_MEDIUM_VERBAL]: {
    question: {
      text: 'This is a verbal multi-choice image question. Please select the correct image.',
      displayText:
        'This is a visual multi-choice image question. Please select the correct image.',
    },
    answerChoices: [
      {
        id: '0',
        choice: {
          images: [images[TEST_IMAGE_TYPES.CORRECT]],
        },
      },
      {
        id: '1',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'This is incorrect - first incorrect targeted verbal feedback',
          },
          secondIncorrect: {
            content:
              'This is incorrect - second incorrect targeted verbal feedback',
          },
        },
      },
      {
        id: '2',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'This is incorrect - first incorrect targeted verbal feedback',
          },
          secondIncorrect: {
            content:
              'This is incorrect - second incorrect targeted verbal feedback',
          },
        },
      },
      {
        id: '3',
        choice: {
          images: [images[TEST_IMAGE_TYPES.INCORRECT]],
        },
        targetedFeedback: {
          firstIncorrect: {
            content:
              'This is incorrect - first incorrect targeted verbal feedback',
          },
          secondIncorrect: {
            content:
              'This is incorrect - second incorrect targeted verbal feedback',
          },
        },
      },
    ],
    answers: ['0'],
    associatedSuccessCriteria: [
      TestAssociatedSuccessCriteria.MULTI_CHOICE_IMAGE,
    ],
  },
};
